import { Component, OnInit, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';

import { AfterContentInit, AfterViewInit, Injectable } from '@angular/core';
import { ViewChild, ElementRef, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { LocationService } from './location.service';
import { Location } from './location';
import { Plan } from '../plans/plan';
import { Customer } from '../customers/customers';
import { debounceTime, finalize, switchMap, startWith, filter, mergeMap } from 'rxjs/operators';
import { API, APIDefinition, Columns, Config, DefaultConfig } from 'ngx-easy-table';
import { Contact } from '../contacts/contact';
import { Subdivision } from '../subdivisions/subdivision';
import { MatRipple } from '@angular/material/core';
import { MessagerComponent } from '../messager/messager/messager.component';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { AuthService } from '../auth.service';
import { LoggingService } from '../utils/logging.service';
import { ScheduleService } from '../schedule/schedule.service';
import { RatingPhotosDialogComponent } from '../schedule/rating-photos/ratingphotos.component';
import { RaterformComponent } from '../raterform/raterform/raterform.component';
import { io } from 'socket.io-client';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { PlanService } from '../plans/plan.service';
import { CustomerService } from '../customers/customers.service';
import { GridEmailComponent } from '../utils/grid-email-component';
import { FormLogsComponent } from './formLogsModal/formLogs.component';
import { DesignsEntity } from '../design/design.model';
import { TagService } from '../utils/tags.service';

@Component({
  selector: 'app-tags-dialog',
  templateUrl: './tags-dialog.html',
  styleUrls: ['./location.component.css']
})
export class TagsDialogComponent implements OnInit {

    tagsData : any;
    form: FormGroup;

    // MF / SF / GPS options for the new tagtypes multi-select.
    tagTypeOptions: string[];

    constructor(public dialogRef: MatDialogRef<TagsDialogComponent>,
                public dialog: MatDialog,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private fb: FormBuilder,
                private service: LocationService,
                private messager: MessagerComponent,
                public tagService: TagService,
                public log: LoggingService) {

        this.tagTypeOptions = this.tagService.TAG_TYPES;

        this.form = this.fb.group({
            displayname: [data.displayname || ''],
            description: [data.description || ''],
            type: [data.type || ''],
            status: [data.status || ''],
            // Classification -> tags.tagtypes text[]. Separate concept from the
            // freeform `type` field above, which carries values like 'HVAC Design'.
            tagtypes: [data.tagtypes || []],
        });
    }

    ngOnInit(): void {

      console.log(this.data)

    }


    onSubmit() {

      var saveObj = this.form.value;
      console.log(saveObj);

      saveObj.createdby = this.data.usernamee;

      this.service.createTag(saveObj).subscribe(
        res => {
          console.log(res);
          this.log.info(this.data.usernamee + ' created a tag ' + this.form.value);
          this.messager.openSnackBar('Tag created', '', 'successAlert');
        }, err => {
          console.log(err);
          this.messager.openSnackBar('Error creating tag' + err, '', 'errorAlert');
        }
      )
    }
}
